export { default } from './AssetDetails.component';
export * from './InspDetails';
export * from './TaskDetails';
